import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import AccountDeletion from './pages/AccountDeletion/AccountDeletion';
import TutorialLibrary from './pages/Tutorial/tutorial';
import './App.css';
import './styles/variables.css';
import './styles/global.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/tutorial" element={<TutorialLibrary />} />
        <Route path="/accountdeletion" element={<AccountDeletion />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;